import { createTheme } from "@mui/material/styles";
import typography from "./typography";

const preventScrollChange = (e) => {
  if (e.target.type === "number") {
    e.target.blur();
  }
};

const baseBorderRadius = 16;
const inputBorderRadius = 24;
const borderRadius = 50;

const baseTheme = createTheme({
  typography,
  shape: {
    borderRadius: baseBorderRadius,
  },
});

const appThemeMui5 = createTheme(baseTheme, {
  components: {
    MuiTextField: {
      defaultProps: {
        onWheel: preventScrollChange,
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius,
        },
      },
      variants: [
        {
          props: { variant: "lifted" },
          style: {
            borderRadius,
            paddingLeft: baseTheme.spacing(3),
            paddingRight: baseTheme.spacing(3),
            paddingTop: baseTheme.spacing(1.25),
            paddingBottom: baseTheme.spacing(1.25),
            fontWeight: 500,
            textTransform: "none",
            color: baseTheme.palette.primary.contrastText,
            backgroundColor: baseTheme.palette.primary.main,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            "&:hover": {
              backgroundColor: baseTheme.palette.primary.dark,
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            },
          },
        },
      ],
    },
    MuiDialog: {
      styleOverrides: {
        paper: {
          width: "100%",
          margin: 0,
          borderRadius: baseTheme.shape.borderRadius * 1.5,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.06)",
          borderRadius: baseTheme.shape.borderRadius,
        },
        elevation1: {
          boxShadow: "0px 1px 2px rgba(0, 0, 0, 0.04), 0px 2px 8px rgba(0, 0, 0, 0.06)",
          borderRadius: baseTheme.shape.borderRadius,
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: inputBorderRadius,
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: inputBorderRadius,
          "& fieldset": {
            borderRadius: inputBorderRadius,
          },
          "&:hover fieldset": {
            borderRadius: inputBorderRadius,
          },
          "&.Mui-focused fieldset": {
            borderRadius: inputBorderRadius,
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: inputBorderRadius,
        },
      },
    },
  },
});

export default appThemeMui5;
